




























































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  students: any[],
  errors: any[],
};

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      students: [],
      errors: [],
    });

    // 一括削除
    const delete_students = async () => {
      if (!confirm('本当に削除してもよろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_cleaning/students_delete`, {students: state.students}).then(response => {
        alert("削除処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/student_cleaning/`).then(response => {
        state.students = response.data.students;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    })


    return {
      ...toRefs(state),
      delete_students,
    }
  }
})
